import { __ } from '@wordpress/i18n';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

jQuery(function ($) {

    if ($(".news-carousel-block").parents(".acf-innerblocks-container").length) {

        $('.swiper-news').each(function () {
            var id = $(this).attr('id');
            const swiper_news = new Swiper('#' + id, {
                modules: [Navigation, Pagination],
                navigation: {
                    nextEl: '.swiper-news-button-next--' + $(this).attr('id'),
                    prevEl: '.swiper-news-button-prev--' + $(this).attr('id'),
                },
                slidesPerView: 1.3,
                spaceBetween: 15,
                breakpoints: {
                    1600: {
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                    },
                    1200: {
                        slidesPerView: 2.2,
                        spaceBetween: 30,
                    },
                    992: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    576: {
                        slidesPerView: 1.8,
                        spaceBetween: 30,
                    }
                }
            });
        });



    } else {

        $('.swiper-news').each(function () {

            var id = $(this).attr('id');
            new Swiper('#' + id, {
                modules: [Navigation, Pagination],
                navigation: {
                    nextEl: '.swiper-news-button-next--' + $(this).attr('id'),
                    prevEl: '.swiper-news-button-prev--' + $(this).attr('id'),
                },
                slidesPerView: 1.3,
                spaceBetween: 15,
                breakpoints: {
                    1600: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    992: {
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    576: {
                        slidesPerView: 1.8,
                        spaceBetween: 30,
                    }
                }
            });
        });


    }

});
